// Property Card Component
export default {
  // Chart Titles
  assetDistribution: "Asset Distribution",
  totalAssetBalanceChange: "Total Asset Balance Change (Last 6 Months)",
  unit: "Unit: USDT",

  // Tooltip
  dataCalculating:
    "Total asset balance change data is being calculated, please check back later",
};
